import { AlertPopup, IAlertPopupParams } from '../../components/AlertPopup/AlertPopup';
import { openPopup } from '../popup/popup';

export function showAlert(data: IAlertPopupParams | string): Promise<void> {
  const params: IAlertPopupParams =
    typeof data === 'string'
      ? {
          text: data,
        }
      : data;

  return new Promise((resolve) =>
    openPopup(AlertPopup, {
      params,
      onClose(): void {
        resolve();
      },
    })
  );
}
